import {
  createAsyncThunk as _createAsyncThunk,
  CreateAsyncThunkFunction,
} from "@reduxjs/toolkit";

import type { AppDispatch, RootState } from "@src/store/rootState";

export interface ThunkConfig {
  state: RootState;
  dispatch: AppDispatch;
}

export const createAsyncThunk: CreateAsyncThunkFunction<ThunkConfig> =
  _createAsyncThunk;
